import { render, staticRenderFns } from "./Targets.vue?vue&type=template&id=52db6cd2&scoped=true&"
import script from "./Targets.vue?vue&type=script&lang=ts&"
export * from "./Targets.vue?vue&type=script&lang=ts&"
import style0 from "./Targets.vue?vue&type=style&index=0&id=52db6cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db6cd2",
  null
  
)

export default component.exports